import { useAppSelector } from "@/stores/hook";
import { selectIsTenantAdmin } from "@/rbac/rbacSlice";
import { useViewConfigGlobalised } from "@/features/leads/api/useLeadFormConfig";

/**
 * "Globalise configs" (Settings → Manage): when the org has it ON, layouts
 * are the admin's to set — everyone else sees them read-only. ONE answer for
 * every layout control (card Show/hide fields, list column drag + resize,
 * Reset Layouts, the drawer tab strip), so no surface can drift.
 *
 * Tenant admins are never locked: their saves are what the workspace
 * inherits. Off (the default) locks nobody.
 */
export function useLayoutLocked(): boolean {
  const globalised = useViewConfigGlobalised();
  const isTenantAdmin = useAppSelector(selectIsTenantAdmin);
  return globalised && !isTenantAdmin;
}

export const LAYOUT_LOCKED_HINT =
  "Layouts are set by your admin for everyone (Settings → Manage → Globalise configs).";
